import { IPatientRelations } from "../../resources-vue/vue-interfaces/i-health";
export class PatientRelations implements IPatientRelations {
    public RelationshipToPatient: number = null;
    public Status: number = 0;
    public Age: number = null;

    public constructor(data?: IPatientRelations) {
        if (!!data) {
            Object.assign(this, data);
        }
    }
}
